import { DragOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { Button } from 'antd';

interface IProp {
  rowKey: string | number;
}

export const DragButton = ({ rowKey }: IProp) => {
  const { listeners, attributes, setActivatorNodeRef } = useSortable({ id: rowKey });

  return (
    <Button
      style={{ cursor: 'move' }}
      ref={setActivatorNodeRef}
      onClick={(e) => e.preventDefault()}
      {...listeners}
      {...attributes}
    >
      <DragOutlined style={{ fontSize: '20px' }} />
    </Button>
  );
};
